import { webWeights } from './webWeights'

export const systemDenseWeights = {
  thin: webWeights.thin,
  light: webWeights.light,
  regular: webWeights.regular,
  semibold: webWeights.semibold,
  bold: webWeights.bold,
}
